import core from './commuCore'
const output = {}

/* —————————————————————— 厂牌相关api —————————————————————— */

function addNewTeam (team) {
  return core.ajax(team, '/team', 'post')
}
output.addNewTeam = addNewTeam

function getTeamPage (query) {
  return core.ajax(query, '/team', 'get')
}
output.getTeamPage = getTeamPage

function deleteTeam (condition) {
  return core.ajax(condition, '/team', 'delete')
}
output.deleteTeam = deleteTeam

function updateTeam (condition) {
  return core.ajax(condition, '/team', 'put')
}
output.updateTeam = updateTeam

function findMember (condition) {
  return core.ajax(condition, '/team/findMember', 'get')
}
output.findMember = findMember

function findTeamName (condition) {
  return core.ajax(condition, '/team/findTeamName', 'get')
}
output.findTeamName = findTeamName

export default output
